import { ApiError } from '../types.js';

export type LinkRequestLifetime = { linkExpiresAt?: number | undefined };

export const LINK_REQUEST_EXPIRED_MESSAGE =
  'This link has expired. Request a new link from your camera or Bridge to continue.';

/** Anchor the server's remaining lifetime locally; client/server clocks may differ. */
export const linkRequestDeadline = (
  response: { expiresAtUnixMs?: number; serverTimeUnixMs?: number },
  receivedAt = Date.now()
): number | undefined => {
  const { expiresAtUnixMs, serverTimeUnixMs } = response;
  // Older servers omit both fields (protobuf defaults to zero). Per global
  // wire-contract-changes-must-not-break-old-firmware, keep their existing flow.
  if (
    !expiresAtUnixMs ||
    !serverTimeUnixMs ||
    !Number.isFinite(expiresAtUnixMs) ||
    !Number.isFinite(serverTimeUnixMs)
  )
    return undefined;
  return receivedAt + Math.max(0, expiresAtUnixMs - serverTimeUnixMs);
};

/** Recheck after asynchronous token reads, not just when the button was rendered. */
export const assertLinkRequestActive = (deadline: number | undefined): void => {
  if (deadline !== undefined && Date.now() >= deadline) {
    throw new ApiError(LINK_REQUEST_EXPIRED_MESSAGE, { code: 412 });
  }
};
